module.exports = __webpack_public_path__ + "img/app-jljd.2e780d57.webp";